import { Box } from "@chakra-ui/react";

import TicketsPerServiceTable from "../../../components/organization/tables/TicketsPerServiceTable";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildTicketVolumeInsights } from "../../../store/reportEnterpriseInsights";

const TicketsByService = ({
  branchId = null,
  reportIndex,
  branchIndex,
  data,
  numServices = 0,
  branchName = null,
}) => {
  const insights = buildTicketVolumeInsights(data, { scopeLabel: "Service" });

  return (
    <Box>
      <EnterpriseReportSummary
        title="Service Ticket Demand Summary"
        kpis={insights.kpis}
        tables={insights.tables}
        notes={insights.notes}
      />
      <TicketsPerServiceTable
        branchId={branchId}
        data={data}
        numServices={numServices}
        branchName={branchName}
        reportIndex={reportIndex}
        branchIndex={branchIndex}
      />
    </Box>
  );
};

export default TicketsByService;
